import * as React from 'react'

import {DIALOG} from './DialogManager'

import * as styles from './Dialog.css'

interface Props {
    id: string;
}

export class DialogOverlay extends React.Component<Props, {}> {

	render() {
		return (
			<div className={styles.dialogOverlay} id={this.props.id}>
				<div className={`${styles.dialogContent} ${DIALOG.CONTENT}`}/>
			</div>
		)
	}
}